import React from "react";
import PropTypes from "prop-types";
import { CardContent } from "components";
import { Col, Row, Card, Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import { withLabelsContext } from "context";
import { IconPencil, IconRocket, IconTrash } from "Icons";
import { useTheme } from "styled-components";
import { Link } from "react-router-dom";
import * as config from "config";
import css from "./card_rubrics_module.scss";
import {Box} from "@mui/material";

function CardRubrics({
  name,
  fromDate,
  toDate,
  audience,
  // selection,
  // class_name,
  ...props
}) {
  const theme = useTheme();
  const redirectionTarget = config.ROUTES.RubricsList;

  const tooltipEdit = <Tooltip id="edit-tooltip">Edit Rubric</Tooltip>;
  const tooltipView = <Tooltip id="view-tooltip">View Rubric</Tooltip>;
  const tooltipDel = <Tooltip id="del-tooltip">Delete Rubric</Tooltip>;

  const RubricsName = name && name.length >= 30 ? name.slice(0, 30) + "..." : name;
  const RubricsAudience =
    audience && audience.length >= 50 ? audience.slice(0, 50) + "..." : audience;
console.log(props,"hey props");

// console.log(audience,"here standard ndjkfjhsnfd");


  return (
    <Box
    sx={{
    position: "relative",
    p: 2,
    borderRadius: "12px",
    backgroundColor: "#F4EFFF",
    height: 200,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    boxShadow: "0px 1px 4px rgba(0,0,0,0.1)",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
    "&:hover": {
      transform: "translateY(-5px)",
      boxShadow: "0px 4px 10px rgba(0,0,0,0.15)",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      top: 0,
      right: 0,
      width: 50,
      height: 50,
      borderTopRightRadius: "12px",
      borderBottomLeftRadius: "50px",
      backgroundColor: theme.color4,
       },
     }}
    >
    <Box {...props} >
        {/* --- Top Row: Name --- */}
        <Row>
          <Col xs={12} onClick={(e) => props.onCardClicked(props.itm)}>
            <h5
              className="name_h5"
              style={{ color: theme.primary, marginBottom: "8px" }}
            >
              {RubricsName}
            </h5>
          </Col>
        </Row>

        {/* --- Second Row: Audience + Dates + Actions --- */}
        <Row className="align-items-start mt-1">
          {/* Left side (Audience + Dates) */}
          <Col xs={9} onClick={(e) => props.onCardClicked(props.itm)}>
            {/* Audience (top of second row) */}
            <div
              className="audience_card"
              style={{
                color: theme.color2,
                fontSize: "14px",
                marginBottom: "32px",
                wordBreak: "break-word",
              }}
            >
              {RubricsAudience}
            </div>

            {/* Start & End Dates (bottom of second row) */}
            <Row>
              <Col>
                <div style={{ color: theme.color3 }} className="date_card1">
                  Start
                </div>
                <div className="date_card">{fromDate}</div>
              </Col>
              <Col style={{ textAlign: "center" }}>
                <div style={{ color: theme.color3 }} className="date_card1">
                  End
                </div>
                <div className="date_card">{toDate}</div>
              </Col>
            </Row>
          </Col>

          {/* Right side: vertically stacked action icons */}
          <Col
            xs={3}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
              justifyContent: "center",
              gap: "6px",
            }}
          >
            <OverlayTrigger placement="left" overlay={tooltipEdit}>
              <Button
                variant="white"
                size="sm"
                style={{
                  padding: "3px 5px",
                  borderRadius: "5px",
                }}
                onClick={(e) => props.onCardClicked(props.itm)}
              >
                <IconPencil />
              </Button>
            </OverlayTrigger>

            <Link to={{ pathname: redirectionTarget, entityData: props.itm }}>
              <OverlayTrigger placement="left" overlay={tooltipView}>
                <Button
                  variant="white"
                  size="sm"
                  style={{
                    padding: "3px 5px",
                    borderRadius: "5px",
                  }}
                  onClick={(e) => props.onCardViewClicked(props.itm)}
                >
                  <IconRocket />
                </Button>
              </OverlayTrigger>
            </Link>

            <OverlayTrigger placement="left" overlay={tooltipDel}>
              <Button
                variant="white"
                size="sm"
                style={{
                  padding: "3px 5px",
                  borderRadius: "5px",
                }}
                onClick={(e) => props.onCardDelete(props.itm)}
              >
                <IconTrash />
              </Button>
            </OverlayTrigger>
          </Col>
        </Row>
    </Box>
    </Box>
  );
}

CardRubrics.propTypes = {
  name: PropTypes.string,
  fromDate: PropTypes.string,
  toDate: PropTypes.string,
  // Selection: PropTypes.string,
  audience:PropTypes.string,
};

export default withLabelsContext(CardRubrics);
